import * as z from "zod";

export const getMiraklSyncStatus = {
  name: "getMiraklSyncStatus" as const,
  input: z.object({}),
  output: z.object({
    connections: z.record(
      z.string(),
      z.object({
        status: z.enum(["running", "completed", "failed"]).optional(),
        lastRunAt: z.string().optional(),
        lastCompletedAt: z.string().optional(),
        imported: z.number().optional(),
        updated: z.number().optional(),
        failed: z.number().optional(),
        error: z.string().nullable().optional(),
      }),
    ),
  }),
};
